import { render, staticRenderFns } from "./LongTermOrder.vue?vue&type=template&id=3edac79f&scoped=true&"
import script from "./LongTermOrder.vue?vue&type=script&lang=js&"
export * from "./LongTermOrder.vue?vue&type=script&lang=js&"
import style0 from "./LongTermOrder.vue?vue&type=style&index=0&id=3edac79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edac79f",
  null
  
)

export default component.exports